import { render, staticRenderFns } from "./activity-seckill.vue?vue&type=template&id=e553494c&scoped=true&"
import script from "./activity-seckill.vue?vue&type=script&lang=js&"
export * from "./activity-seckill.vue?vue&type=script&lang=js&"
import style0 from "./activity-seckill.vue?vue&type=style&index=0&id=e553494c&prod&lang=less&scoped=true&"
import style1 from "./activity-seckill.vue?vue&type=style&index=1&id=e553494c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e553494c",
  null
  
)

export default component.exports